export const helpGuideLink =
  'https://pwceur.sharepoint.com/:u:/r/sites/GBL-xLoS-Junction/SitePages/Junction-Next-How-To-Guides.aspx?csf=1&web=1&e=AnkBA8';

export const junctionNextUrls = {
  dev: 'https://cde-junction-dev.pwcinternal.com/',
  qa: 'https://cde-junction-qa.pwcinternal.com/',
  stage: 'https://junction-stage.pwc.com/',
  uat: 'https://junction-uat.lower-pwclabs.pwc.com/',
  prod: 'https://junction.pwc.com/',
  load: 'https://cde-junction-load.pwcinternal.com',
  patch: 'https://cde-junction-patch.pwcinternal.com',
};
